import { gql } from '@apollo/client';

export const FETCH_UNKNOWN_USER_TEMPLATES = gql`
    query FetchUnknownUserTemplates {
        system {
            unknownUserTemplates {
                id
                domain
            }
        }
    }
`;
